(function ($) {
  $(document).ready(function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    // 1. Default setup for the parallax engine
    let parallaxConfig = {
      enabled: true,         // Allows child themes to turn it off completely
      distance: 80,          // The +/- pixel amount the image will travel radially around 0
      selectors: '.image-container:not(.no-parallax)' // Which containers are eligible
    };

    // 2. Allow child theme overriding via global object
    if (window.parallaxAnimationConfig) {
      if (window.parallaxAnimationConfig.enabled === false) return; // Immediate opt-out override
      parallaxConfig = Object.assign({}, parallaxConfig, window.parallaxAnimationConfig);
    }

    if (!parallaxConfig.enabled) return;

    // 3. Find eligible containers and evaluate their direct nested <img> elements
    $(parallaxConfig.selectors).each(function () {
      const $container = $(this);
      // Target ONLY the direct child <img> per requirement
      const $images = $container.children('img');
      if ($images.length === 0) return;

      // Force overflow hidden on the container to bound the parallax window without needing child theme CSS
      gsap.set($container, { overflow: 'hidden' });

      // Scale the image strictly larger than its bounding box by twice the travel distance
      // Then negatively offset it to center the overflow. This guarantees no transparent gaps at the extremities.
      gsap.set($images, { 
        width: `calc(100% + ${parallaxConfig.distance * 2}px)`,
        height: `calc(100% + ${parallaxConfig.distance * 2}px)`,
        marginTop: -parallaxConfig.distance,
        marginLeft: -parallaxConfig.distance,
        maxWidth: 'none',
        objectFit: 'cover'
      });
      // 4. Bind the scrub timeline to each image
      $images.each(function () {
        gsap.fromTo(this, 
          { 
            y: parallaxConfig.distance // Starts pushed DOWN 40px
          }, 
          { 
            y: -parallaxConfig.distance, // Ends pulled UP 40px
            ease: 'none',                // Linear easing; essential for smooth native scroll-syncing
            scrollTrigger: {
              trigger: $container,       // The scroll calculations are based on the container boundaries
              start: 'top bottom',       // Animation starts exactly when the top of the container touches the bottom of the viewport
              end: 'bottom top',         // Animation finishes when the bottom of the container touches the top of the viewport
              scrub: true                // Smoothly tie the percentage of the tween to the percentage of the scroll depth
            }
          }
        );
      });
    });

  });
})(jQuery);
